'use client';
import React, { useState } from 'react';
import { Sidebar, SidebarBody, SidebarLink } from "@/components/ui/sidebar";
import Link from 'next/link';
import Icons from '../ui/icons';
import { Button } from '../ui/button';
import AnimatedSwitch from '../utils/animation-switch';
import { cn } from '@/lib/utils';
import { signOut } from 'next-auth/react';
const SidebarWrapper = ({ links, children }: { links: any, children: React.ReactNode }) => {
    const [open, setOpen] = useState(true);

    const Logo = () => {
        return (
            <div className="w-full flex flex-col gap-5 static md:sticky top-0 z-20 shadow-none  bg-transparent md:bg-[#1B1723] md:shadow-xl ">
                <div className='flex items-center w-full gap-2 px-2'>
                    <div className='flex items-center justify-center backdrop-blur-lg bg-gradient-to-tr from-transparent via-[rgba(121,121,121,0.43)] to-transparent rounded-md p-2 shadow duration-700'>
                        <Icons.icon className='w-9 h-9' />
                    </div>
                    <div className='flex flex-col justify-center items-start '>
                        <p className='text-[16px]'>نام فروشگاه </p>
                        <p className='text-[12px]'>برترین مارکت فارسی </p>
                    </div>
                </div>
                <Icons.linedivider className='px-7 text-[#e0e1e27e]' />
            </div>
        );
    };
    const LogoIcon = () => {
        return (
            <Link
                href="#"
                className="font-normal flex space-x-2 items-center text-sm py-1 px-4 relative z-20 "
            >
                <Icons.icon className='w-9 h-9' />

            </Link>
        );
    };

    return (
        <Sidebar open={open} setOpen={setOpen}>
            <SidebarBody className="justify-between gap-10 ">
                <div className={cn("flex flex-col flex-1", open && "overflow-auto overflow-x-hidden")}>
                    {open ? <Logo /> : <LogoIcon />}
                    <div className={cn("mt-8 flex flex-col gap-[6px] ", !open && "justify-between h-full")}>
                        <div className='space-y-2'>
                            {links.map((link: any, idx: any) => (
                                <SidebarLink key={idx} link={link} />
                            ))}
                        </div>
                        <Link onClick={() => signOut()} href='#' className={cn("flex items-center justify-start gap-3 group/sidebar py-2 px-4 relative", !open && "gap-5")}  >
                            <div className={cn(!open && "border border-input bg-accent/20 w-9 max-w-9 min-w-9 h-9 flex items-center justify-center rounded-sm ml-1", !open ? "" : "opacity-100")}>
                                <Icons.exit className="h-6 w-6 " />
                            </div>

                            <span
                                className="text-[14px] group-hover/sidebar:translate-x-1 transition duration-150 whitespace-pre inline-block !p-0 !m-0"
                            >
                                <div className={cn("text-[#F9F9FA]")}>
                                    خروج
                                </div>
                            </span>
                        </Link>
                    </div>
                </div>

                {open && (
                    <AnimatedSwitch active={true} duration={0.8} ease='backInOut'>
                        <div className='w-full px-4'>
                            <div className='relative rounded-2xl border-[1px] border-[#b2b2b21a] p-4 overflow-hidden'>
                                <div className='absolute bottom-0 inset-x-0 h-10 bg-[#44218b73] rounded-t-full blur-md'></div>

                                <div className='w-full space-y-6'>
                                    <div className='w-9 h-9 flex items-center justify-center bg-[#44218b] shadow-[5px_5px_rgba(63,_39,_88,_0.4)] rounded-lg'>
                                        <Icons.questionicon className='w-5 h-5 p-1 bg-[#f9f9fad3] rounded-full' />
                                    </div>

                                    <div className='space-y-4'>
                                        <div>
                                            <p className='text-md'>به کمک نیاز دارید ؟</p>
                                            <p className='text-[10px]'>این داکیومنت را برسی کنید</p>
                                        </div>
                                        <Button className='w-full backdrop-blur-sm' variant='subtle'>
                                            مستندات سایت
                                        </Button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </AnimatedSwitch>
                )}
            </SidebarBody>
            {children}
        </Sidebar>
    );
};

export default SidebarWrapper;


